module.exports = __webpack_public_path__ + "static/media/czech-flag.d444041d.png";